<template>
  <page-table />
</template>
<script>
import PageTable from './table'
export default {
  name: 'ecom-awsBiz-amzPeriodSet',
  components: { PageTable }
}
</script>
